export class TaxYearHelper {
    static GetCurrentTaxYear(): number {
        return this.GetTaxYear(new Date());
    }

    static GetTaxYear(date: Date): number {
        let taxYear = date.getFullYear();

        if (date.getMonth() < 3 || (date.getMonth() == 3 && date.getDate() < 6)) {
            taxYear = taxYear - 1;
        }

        return taxYear;
    }

    static GetTaxYearStartDate(taxYear: number): Date {
        return new Date(taxYear, 3, 6);
    }

    static GetTaxYearEndDate(taxYear: number): Date {
        return new Date(taxYear + 1, 3, 5);
    }
}
